import React from 'react'
import TimelineConnector from '@mui/lab/TimelineConnector'
import TimelineDot from '@mui/lab/TimelineDot'
import './Timeline.css'

function CustomTimelineLast () {
  return (
    <div className='separator-padding'>
      <TimelineDot variant='outlined' className='timeline-dot' />
      <TimelineConnector />
    </div>
  ) 
}

export default CustomTimelineLast
